module.exports = new __parcel__URL__("gallery_14.4c843993.jpeg").toString();